<template>
<!-- 课程 -->
    <div>
        <div class="title">
            <p class="fl">
                <img src="@/assets/logoe.png" alt="">
                专题课程
            </p>
            <p @click="go" class="fr">查看更多</p>
        </div>

        <div class="videos" v-for="item in list" :key="item.url">
            <img :src="item.img" alt="" @click="special(item)">
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    data(){
        return{
            list:[      
                {img:'https://img.qiaoxuesi.com/market/outImg/1587717418096.JPG',url:'https://lubo.gankao.com/tag/xxastfs'},     
                {img:'https://img.qiaoxuesi.com/market/outImg/1541055361844.JPG',url:'https://lubo.gankao.com/tag/free1'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540881644399.JPG',url:'https://lubo.gankao.com/tag/jtjy'},
            ]
        }
    },
    mounted(){
        this.getuser()
    },
    methods:{
        go(){
            this.specialwork()
            this.$router.push('/CourseDetails')
        },
        // 跳转
        special(item){
            window.location.href = item.url
        },
        // 数据上报
        // 个人信息 
        getuser(){
            this.$axios({
                method: "post",
                url: 'https://api.rujiaowang.net/index.php/api/user/get_user',
                data: {
                token: localStorage.getItem('token'),
                },
            }).then(res =>{
                this.iteminfo = res.data.result
            })
        },
        // 专题课程
        specialwork(){
            this.$axios({
                method: "get",
                url: 'http://access.rujiaowang.net/GetLogServer',
                data: {
                    token: localStorage.getItem('token'),
                },
            }).then(res =>{
                this.client_ip = res.data.result.client_ip
                var actualtime = res.data.result.net_ts - Date.parse(new Date()) / 1000 // 服务器时间跟计算机时间差值

                if(JSON.parse(localStorage.getItem("userInfo")).user_type == 3){
                    var school_name = String(this.iteminfo.school) //学校
                    var school_id = String(this.iteminfo.school_id) //学校id
                    var data1 = {
                        school_name: school_name,
                        school_id: school_id,
                        trace_id: localStorage.getItem('apptrace'),
                    }
                } else if(JSON.parse(localStorage.getItem("userInfo")).user_type == 5){
                    var school_name = String(this.iteminfo.school) //学校
                    var school_id = String(this.iteminfo.school_id) //学校id
                    var grade_id = String(this.iteminfo.grade) //学校id
                    var class_name = String(this.iteminfo.myclass) //学校id
                    var class_id = String(this.iteminfo.myclass_id) //学校id
                    var list = [
                        {id:1,text:'一'},
                        {id:2,text:'二'},
                        {id:3,text:'三'},
                        {id:4,text:'四'},
                        {id:5,text:'五'},
                        {id:6,text:'六'},
                        {id:7,text:'七'},
                        {id:8,text:'八'},
                        {id:9,text:'九'},
                    ]
                    for (let index = 0; index < list.length; index++) {
                        if(grade_id == list[index].id){
                            var grade_name = list[index].text
                        }
                    }
                    var data1 = {
                        school_name: school_name,
                        school_id: school_id,
                        grade_name: grade_name + '年级',
                        grade_id: grade_id,
                        class_name: class_name,
                        class_id: class_id,
                        trace_id: localStorage.getItem('apptrace'),
                    }
                } else if(JSON.parse(localStorage.getItem("userInfo")).user_type == 2) {
                    var data1 = {
                        trace_id: localStorage.getItem('apptrace'),
                    }
                }
                if(this.Mobile == 'pad'){
                    var saydata = {
                        log_version: "v2.0.0", 
                        action:  "special_entrance",
                        product_name: localStorage.getItem('product_name'),
                        user_id: String(this.iteminfo.user_id),
                        user_role: String(this.iteminfo.user_type),
                        ts: String(Number(Date.parse(new Date())) / 1000 + actualtime), // 真实时间
                        trace_id: localStorage.getItem('trace'),
                        dev_id: '',
                        dev_name: '',
                        client_ip: this.client_ip,
                        os: '',
                        cpu_name: '',
                        cpu_use: '',
                        app_version: 'v2.0.0',
                        mem_size: '',
                        mem_use: '',
                        net: '',
                        electric: '',
                        user_name: this.iteminfo.user_nicename,
                        "@": '',
                        extend: '',
                        remark: String(this.iteminfo.user_nicename + '进入了专题课程'),
                        data: data1
                    }
                    $.ajax({
                        method: "post",
                        url: 'http://47.114.114.56:9002/RecordRjw',
                        data: JSON.stringify(saydata),
                    }).then(res =>{})
                } 
                else {
                    var saydata = {
                        log_version: "v2.0.0", 
                        action:  "special_entrance",
                        product_name: localStorage.getItem('product_name'),
                        user_id: String(this.iteminfo.user_id),
                        user_role: String(this.iteminfo.user_type),
                        ts: String(Number(Date.parse(new Date())) / 1000 + actualtime), // 真实时间
                        trace_id: localStorage.getItem('trace'),
                        dev_id: '',
                        dev_name: '',
                        client_ip: this.client_ip,
                        os: '',
                        cpu_name: '',
                        cpu_use: '',
                        app_version: 'v2.0.0',
                        mem_size: '',
                        mem_use: '',
                        net: '',
                        electric: '',
                        user_name: this.iteminfo.user_nicename,
                        "@": '',
                        extend: '',
                        remark: String(this.iteminfo.user_nicename + '进入了专题课程'),
                        data: data1
                    }
                    $.ajax({
                        method: "post",
                        url: 'http://47.114.114.56:9002/RecordRjw',
                        data: JSON.stringify(saydata),
                    }).then(res =>{})
                }
            })
        }
    }
}
</script>

<style scoped>
.title{
    padding: 0 0.4rem;
    line-height: 50px;
}
.title p:first-child{
    margin: 0;
    font-size: 16px;
}
.title p:first-child img{
    width: 20px;
}
.title p:last-child{
    margin: 0;
    color: #a9a9a9;
    font-size: 0.32rem;
}
.videos{
    padding: 0 0.4rem 0.06rem;
}
.videos img{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/shouyeZhuanti.vue